<template>
    <div class="head">
        <div class="logo_box">
            <img src="../../assets/static/index/icons.png" alt="">
            <div class="dept_name">
                {{ userInfo.deptName }}
            </div>
        </div>
        <div class="nav_box">
            <div class="nav_item" v-for="(item, index) in NavList" :key="index" @click="changePath(item)">
                <div class="name" v-if="index == 3">
                    <el-dropdown @command="handleCommand" :hide-on-click="false" trigger="click">
                        <span class="el-dropdown-link" style="color:#fff;font-size:19px;">
                            {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width:150px;">
                            <el-dropdown-item command="1">组织概况</el-dropdown-item>
                            <el-dropdown-item command="10">党建新闻</el-dropdown-item>

                        </el-dropdown-menu>
                        </el-dropdown>
                </div>
                <div v-else>
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="notify" @click="showNotify">
            <span class="iconfont icon-gaojingtongzhi"></span>
            <span class="txt">通知</span>
        </div>
        <div class="user_avatar">
            <div class="avatar_box">
                <img class="hvr-grow" :src="userInfo.avatar" v-if="userInfo.avatar && userInfo.avatar.indexOf('http') != -1" alt="">
                <img class="hvr-grow" :src="$ImgUrl + userInfo.avatar" v-if="userInfo.avatar && userInfo.avatar.indexOf('http') == -1" alt="">
                <img class="hvr-grow" src="../../assets/static/index/default.png" v-if="!userInfo.avatar" alt="">
            </div>
            <el-dropdown @command="handleCommandUser">
                <span class="el-dropdown-link">
                    {{ userInfo.userName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">
                        <span class="el-icon-user"></span>
                        个人中心
                    </el-dropdown-item>
                    <!-- <el-dropdown-item>
                        <span class="el-icon-lightning"></span>
                        资料下载
                    </el-dropdown-item> -->
                    <el-dropdown-item command="3">
                        <span class="el-icon-switch-button"></span>
                        退出登录
                    </el-dropdown-item>
                    
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                NavList: [
                    { iconClass: "icon-shouye1", name: "首页" , path: "/"},
                    { iconClass: "icon-zixun", name: "党建资讯" , path: "/djzx"},
                    { iconClass: "icon-zuzhi-copy", name: "组织生活", path: "/zzsh" },
                    { iconClass: "icon-dangjian", name: "党的建设" },
                    { iconClass: "icon-zhuanti", name: "党的专题", path: "/temp" },
                    { iconClass: "icon-wangluodangxiao", name: "红色学堂" , path:"/RedSchool"},
                    { iconClass: "icon-fuwudating", name: "服务大厅" , path: "/server"},
                    { iconClass: "icon-ditu1", name: "党建地图", path: "/map" }
                ], // 导航列表
                userInfo: {},
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted() {
            if ( this.token ) {
                this.getUserInfo()
            }
        },
        methods: {
            // 个人信息页
            editUser () {
                this.$router.push("/editUserInfo")
            },
            userIndex() {
                this.$router.push("/user")
            },
            // 下拉按钮事件
            handleCommandUser ( com  ) {
                console.log( com )
                if ( com == '1' ) {
                    this.userIndex()
                } else if ( com == '3' ) {
                    this.loginOut()
                }
            },
            // 跳转
            changePath ( item ) {
                this.$router.push( item.path )
            },
            // 退出登录
            loginOut () {
                localStorage.removeItem("token")
                this.$store.commit("getToken", "")
                this.$router.push("/login")
            },
             // 获取用户信息
            async  getUserInfo () {
                let { token } = this 
                let res = await this.$axios.post("/lencon/pc/person/simple_info", { token  })
                if ( res.data.code == 1 ) {
                    this.userInfo = res.data.obj
                } 
            },

            // 点击通知
            showNotify () {
                this.$router.push("/user/notify")
            },
            // 指令事件
            handleCommand ( id ) {
                this.$router.push(`/notify/${ id }`)
            }
        }
    }
</script>

<style lang="scss" scoped>
.head {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    .logo_box {
        display: flex;
        align-items: center;
        .dept_name {
            font-size: 26px;
            font-weight: bold;
            color: #fff;
            margin-left: 20px;
        }
    }
    .nav_box {
        margin: 0 20px;
        display: flex;
        font-size: 19px;
        color: #fff;
        .nav_item {
            // width: 100px;
            width: 120px;
            text-align: center;
            cursor: pointer;
        }
    }
    .user_avatar {
        display: flex;
        align-items: center;
        color: #fff;
        .avatar_box {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            overflow: hidden;
            border: 2px solid #fff;
        }
        img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            overflow: hidden;
        }
        .el-dropdown {
            margin-left: 10px;
            cursor: pointer;
            .el-dropdown-link {
                color: #fff;
            }
        }
        
    }
    .notify {
        color: #fff;
        margin:  0 20px;
        padding: 0 20px;
        font-size: 18px;
        border-right: 1px solid #fff;
        cursor: pointer;
        .txt {
            margin-left: 10px;
        }
    }
}
</style>